import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentEndSimpleInfoComponent } from '@gk/gk-modules';
import { AccessibilityStatementWrapperComponent } from './components/accessibility-statement-wrapper/accessibility-statement-component-wrapper';
import { NoAccessComponent } from './components/no-access/no-access.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
import { MainRouteParams, MainRoutes } from './guards/guard.models';
import { NoSessionGuard } from './guards/no-session/no-session.guard';
import { PortalConfigAccessGuard } from './guards/portal-config-access/portal-config-access.guard';
import { SessionGuard } from './guards/session/session.guard';
import { SignInConfigAccessGuard } from './guards/sign-in-config-acccess/sign-in-config-access.guard';
import { DocumentVerificationFormWrapperComponent } from './modules/office-departments-portal/departments/geodesy/modal-document-verification/forms/document-verification-form-wrapper/document-verification-form-wrapper.component';

const routes: Routes = [
  {
    path: `:${MainRouteParams.ParentRoute}/${MainRoutes.SignIn}`,
    canActivate: [SignInConfigAccessGuard],
    loadComponent: () =>
      import('./components/sign-in/sign-in.component').then(
        (m) => m.SignInComponent,
      ),
  },
  {
    path: MainRoutes.SurveyorPortal,
    canActivate: [PortalConfigAccessGuard],
    loadChildren: () =>
      import('./modules/surveyor-portal/surveyor-portal.module').then(
        (m) => m.SurveyorPortalModule,
      ),
  },
  {
    path: MainRoutes.AppraiserPortal,
    canActivate: [PortalConfigAccessGuard],
    loadChildren: () =>
      import('./modules/appraiser-portal/appraiser-portal.module').then(
        (m) => m.AppraiserPortalModule,
      ),
  },
  {
    path: MainRoutes.EwidPro,
    canActivate: [PortalConfigAccessGuard],
    loadChildren: () =>
      import('./modules/ewid-pro-portal/ewid-pro-portal.module').then(
        (m) => m.EwidProPortalModule,
      ),
  },
  {
    path: MainRoutes.PresentationCommentsLandBuildingRegistryProject,
    loadChildren: () =>
      import(
        './modules/presentation-comments-land-building-registry-project/presentation-comments-land-building-registry-project.module'
      ).then((m) => m.PresentationCommentsLandBuildingRegistryProjectModule),
  },
  {
    path: MainRoutes.GrantingRights,
    canActivate: [SessionGuard],
    loadChildren: () =>
      import(
        './modules/granting-rights-portal/granting-rights-portal.module'
      ).then((m) => m.GrantingRightsPortalModule),
  },
  {
    path: MainRoutes.InterMod,
    canActivate: [SessionGuard],
    loadChildren: () =>
      import('./modules/intermod/intermod.module').then(
        (m) => m.InterModModule,
      ),
  },
  { path: '404', component: PageNotFoundComponent },
  { path: 'no-access', component: NoAccessComponent },
  {
    path: 'accessibility-statement-regular',
    component: AccessibilityStatementWrapperComponent,
  },
  {
    path: 'accessibility-statement-mobile',
    component: AccessibilityStatementWrapperComponent,
  },
  {
    path: 'accessibility-statement-forClient',
    component: AccessibilityStatementWrapperComponent,
  },
  {
    path: 'document-verification',
    component: DocumentVerificationFormWrapperComponent,
  },
  {
    path: 'payment-success',
    component: PaymentSuccessComponent,
  },
  {
    path: 'payment-end-simple-info',
    component: PaymentEndSimpleInfoComponent,
  },
  {
    path: MainRoutes.CoordinationMeetingPortal,
    canActivate: [PortalConfigAccessGuard],
    loadChildren: () =>
      import(
        './modules/coordination-meeting-portal/coordination-meeting-portal.module'
      ).then((m) => m.CoordinationMeetingPortalModule),
  },
  {
    path: MainRoutes.BailiffPortal,
    canActivate: [PortalConfigAccessGuard],
    loadChildren: () =>
      import('./modules/bailiff-portal/bailiff-portal.module').then(
        (m) => m.BailiffPortalModule,
      ),
  },
  {
    path: MainRoutes.LandUtilitiesSpecialistPortal,
    canActivate: [PortalConfigAccessGuard],
    loadChildren: () =>
      import(
        './modules/land-utilities-specialist-portal/land-utilities-specialist-portal.module'
      ).then((m) => m.LandUtilitiesSpecialistPortalModule),
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  providers: [SessionGuard, NoSessionGuard],
})
export class AppRoutingModule {}
